import request, { Methods, withToken } from "../../../../utils/request";

//* ACTIONTYPES --------------------------------------------
export const POST_COPY_WEEK_DEFAULT = "POST_COPY_WEEK_DEFAULT";
export const POST_COPY_WEEK_REQUEST = "POST_COPY_WEEK_REQUEST";
export const POST_COPY_WEEK_SUCCESS = "POST_COPY_WEEK_SUCCESS";
export const POST_COPY_WEEK_ERROR = "POST_COPY_WEEK_ERROR";

//* ACTIONS ------------------------------------------------
export const postCopyWeekDefault = () => ({
  type: POST_COPY_WEEK_DEFAULT,
});

export const postCopyWeekRequest = (payload = {}, callback) => ({
  type: POST_COPY_WEEK_REQUEST,
  payload,
  callback,
});

export const postCopyWeekSuccess = () => ({
  type: POST_COPY_WEEK_SUCCESS,
});

export const postCopyWeekError = (error) => ({
  type: POST_COPY_WEEK_ERROR,
  payload: error,
});

//* REQUEST SERVICE ---------------------------------------
export const postCopyWeekServiceRequest = async (data) => {
  const options = await withToken({
    method: Methods.POST,
    data,
  });

  return request("/schedules/weeks/copy", options);
};
